<div class="details-container">
  <app-sidenav-header [title]="title" [subtitle]="data?.name" headerIcon="batch_prediction"></app-sidenav-header>
  <div class="flex flex-col">
    <div class="flex flex-row justify-between items-center">
      <div class="fw-700 column-width">{{'SOLUTIONS.SOLUTION_NAME' | transloco}}</div>
      <div class="fw-700 column-width">{{'SOLUTIONS.VERSION' | transloco}}</div>
      <div class="fw-700 column-width">{{'SOLUTIONS.RELEASE_VERSION' | transloco}}</div>
      <div class="fw-700 column-width">{{'SOLUTIONS.STATUS' | transloco}}</div>
      <div class="fw-700 column-width">{{'SOLUTIONS.CREATED_DATE' | transloco}}</div>
      <div class="fw-700 column-width">{{'SOLUTIONS.UPDATED_DATE' | transloco}}</div>
    </div>
    <div class="flex flex-row justify-between">
      <div class="overview-values column-width">{{data?.name ? data?.name : '--'}}</div>
      <div class="overview-values column-width">{{data?.version ? data?.version : '--'}}</div>
      <div class="overview-values column-width">{{data?.releaseVersion ? data?.releaseVersion : '--'}}</div>
      <div class="overview-values column-width">{{data?.status ? data?.status : '--'}}</div>
      <div class="overview-values column-width">{{dateTimeFormatService.getUtcFromat(data?.dateCreated) ? dateTimeFormatService.getUtcFromat(data?.dateCreated) : '--'}}</div>
      <div class="overview-values column-width">{{dateTimeFormatService.getUtcFromat(data?.dateUpdated) ? dateTimeFormatService.getUtcFromat(data?.dateUpdated) : '--'}}</div>
    </div>
  </div>
  <mat-divider class="mb-20 mt-20 neutral-2"></mat-divider>
  
  <mat-tab-group>
    <mat-tab label="{{'TENANT_DETAILS.DETAILS' | transloco }}">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'SOLUTIONS.DETAILS' | transloco}}
            </mat-panel-title>
          </mat-expansion-panel-header>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.ID' | transloco}}
              </div>
              <div>
                {{data?.id ? data?.id : '-'}}
              </div>
            </div>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.SOLUTION_ID' | transloco}}
              </div>
              <div>
                {{data?.solutionId ? data?.solutionId : '-'}}
              </div>
            </div>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.DESCRIPTION' | transloco}}
              </div>
              <div>
                {{data?.description ? data?.description : '-'}}
              </div>
            </div>
            <!-- <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.RELEASE_NOTES' | transloco}}
              </div>
              <div>
                {{data?.releaseNotes ? data?.releaseNotes : '-'}}
              </div>
            </div> -->
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.SANDBOX_TYPE' | transloco}}
              </div>
              <div>
                {{data?.sandboxType ? data?.sandboxType : '-'}}
              </div>
            </div>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.INSTALLATION_SPECIFICATION' | transloco}}
              </div>
              <div *ngIf="!data?.installationSpecification">
                {{'-'}}
              </div>
              <div>
                <a *ngIf="data?.installationSpecification" class="items-center fw-400 fs-14 ml-10" href="javascript:void(0)" (click)="onClick(data?.installationSpecification)">{{'SOLUTIONS.VIEW' | transloco}}</a>
              </div>
            </div>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.SANDBOX_SPECIFICATION' | transloco}}
              </div>
              <div *ngIf="!data?.sandboxInstallationSpec">
                {{'-'}}
              </div>
              <div>
                <a *ngIf="data?.sandboxInstallationSpec" class="items-center fw-400 fs-14 ml-10" href="javascript:void(0)" (click)="onClickSandbox(data?.sandboxInstallationSpec)">{{'SOLUTIONS.VIEW' | transloco}}</a>
              </div>
            </div>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.SPEC_VERSION' | transloco}}
              </div>
              <div>
                {{data?.specVersion ? data?.specVersion : '-'}}
              </div>
            </div>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.ATF_VERSION' | transloco}}
              </div>
              <div>
                {{data?.atf?.version ? data?.atf?.version : '-'}}
              </div>
            </div>
            <div class="flex flex-row">
              <div class="metrics pt-8 pb-8">
                {{'SOLUTIONS.CBASE_VERSION' | transloco}}
              </div>
              <div>
                {{data?.cbase?.version ? data?.cbase?.version : '-'}}
              </div>
            </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-tab>

    <mat-tab label="{{'SOLUTIONS.CAPABILITIES' | transloco }}">
      <div class="flex flex-row cards-section">
        <mat-card class="metrics-card mr-16 mb-16">
          <mat-card-content>
            <div class="fw-500 tile-header">
              {{'SOLUTIONS.MANDATORY' | transloco }}
            </div>
            <div>
              {{capabilities?.mandatory?.length ? capabilities?.mandatory?.length : 0}}
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="metrics-card mr-16 mb-16">
          <mat-card-content>
            <div class="fw-500 tile-header">
              {{'SOLUTIONS.OPTIONAL' | transloco }}
            </div>
            <div>
              {{capabilities?.optional?.length ? capabilities?.optional?.length : 0}}
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <mat-accordion *ngIf="capabilities?.mandatory?.length > 0">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'SOLUTIONS.MANDATORY' | transloco}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="pt-8 pb-8">
            <table mat-table [dataSource]="capabilities?.mandatory" class="mat-elevation-z8">
              <ng-container matColumnDef="name">
                <th mat-header-cell class="fs-14" *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element?.name ? element?.name : '--'}} </td>
              </ng-container>
              <ng-container matColumnDef="version">
                <th mat-header-cell class="fs-14" *matHeaderCellDef> Version </th>
                <td mat-cell *matCellDef="let element"> {{element?.version ? element?.version : '--'}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion *ngIf="capabilities?.optional?.length > 0">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{'SOLUTIONS.OPTIONAL' | transloco}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="pt-8 pb-8">
            <table mat-table [dataSource]="capabilities?.optional" class="mat-elevation-z8">
              <ng-container matColumnDef="name">
                <th mat-header-cell class="fs-14" *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element?.name ? element?.name : '--'}} </td>
              </ng-container>
              <ng-container matColumnDef="version">
                <th mat-header-cell class="fs-14" *matHeaderCellDef> Version </th>
                <td mat-cell *matCellDef="let element"> {{element?.version ? element?.version : '--'}} </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-tab>

  </mat-tab-group>
</div>
  